import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a1c6d710")

_pushScopeId("data-v-a1c6d710")
const _hoisted_1 = { class: "performanceOverview" }
const _hoisted_2 = { class: "dialogForm" }
const _hoisted_3 = { class: "dialogTitle" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "文件上传", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "el-icon-upload" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" 将文件拖到此处，或 "),
  /*#__PURE__*/_createVNode("em", null, "点击上传")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "el-upload__tip" }, "只能上传log文件", -1)
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("重 置")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("确 定")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("文件上传")
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_progress = _resolveComponent("el-progress")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_empty = _resolveComponent("el-empty")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogVisible1,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogVisible1 = $event)),
                    width: "30%",
                    onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogVisible1 = false))
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode("span", _hoisted_8, [
                        _createVNode(_component_el_button, {
                          size: "small",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.UploadProblem('no')))
                        }, {
                          default: _withId(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "primary",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.UploadProblem('ok')))
                        }, {
                          default: _withId(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        model: _ctx.dialogForm,
                        size: "small",
                        "label-position": "top"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "名称" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.svg_name,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.svg_name = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "上传文件" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_upload, {
                                class: "upload-demo",
                                drag: "",
                                action: "http://127.0.0.1:8081/api/v1/performance_log/ds_log_upload/",
                                multiple: "",
                                limit: 1,
                                "before-upload": _ctx.beforeUploadTop,
                                ref: 'uploadTop',
                                "http-request": _ctx.UploadFileTop
                              }, {
                                tip: _withId(() => [
                                  _hoisted_7
                                ]),
                                default: _withId(() => [
                                  _hoisted_5,
                                  _hoisted_6
                                ]),
                                _: 1
                              }, 8, ["before-upload", "http-request"]),
                              (_ctx.progressFlag)
                                ? (_openBlock(), _createBlock(_component_el_progress, {
                                    key: 0,
                                    percentage: _ctx.loadProgress
                                  }, null, 8, ["percentage"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createVNode(_component_el_card, { class: "spacName" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form, {
                      class: "spacForm",
                      size: "mini",
                      inline: true
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "文件名" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              onChange: _ctx.svgChange,
                              modelValue: _ctx.svgName,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.svgName = $event)),
                              placeholder: "请选择项目"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.svgLogList, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.name,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["onChange", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.deleteBtn,
                              size: "mini"
                            }, {
                              default: _withId(() => [
                                _hoisted_11
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { label: "" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              size: "mini",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.UploadProblem('open')))
                            }, {
                              default: _withId(() => [
                                _hoisted_12
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.svgLogData.results?.length > 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_13, [
                          _withDirectives(_createVNode(_component_el_table, {
                            border: "",
                            size: "mini",
                            "header-cell-style": {
                  background: '#5D99D5',
                  color: '#fff',
                },
                            data: _ctx.svgLogData.results?.length > 0 ? _ctx.svgLogData.results : []
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, { label: "路径" }, {
                                default: _withId((scope) => [
                                  _createTextVNode(_toDisplayString(scope.row.path), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "log类型",
                                width: "150"
                              }, {
                                default: _withId((scope) => [
                                  _createTextVNode(_toDisplayString(scope.row.level), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "出现次数",
                                width: "150"
                              }, {
                                default: _withId((scope) => [
                                  _createTextVNode(_toDisplayString(scope.row.count), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, {
                                label: "占比",
                                width: "150"
                              }, {
                                default: _withId((scope) => [
                                  _createTextVNode(_toDisplayString(scope.row.rate), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data"]), [
                            [_directive_loading, _ctx.svn_loading]
                          ]),
                          _createVNode(_component_el_form, {
                            class: "spacName",
                            inline: true,
                            size: "mini",
                            style: {"display":"flex","align-items":"center"}
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "每页" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.pageChange(true))),
                                    modelValue: _ctx.record,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.record = $event)),
                                    style: {"width":"55px","height":"28px"}
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "条记录" }),
                              _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_pagination, {
                                    onCurrentChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.pageChange(false))),
                                    currentPage: _ctx.current_page,
                                    "onUpdate:currentPage": _cache[11] || (_cache[11] = ($event: any) => (_ctx.current_page = $event)),
                                    "page-size": _ctx.record,
                                    layout: "total, prev, pager, next, jumper",
                                    total: _ctx.svgLogData?.count
                                  }, null, 8, ["currentPage", "page-size", "total"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_14, [
                          _createVNode(_component_el_empty, { description: "暂无上传数据" })
                        ]))
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})